import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["autoComplete", "active", "defaultHide", "renderShowToggle"];
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { BareInput } from "./BareInput";
import { hasValue } from "../validator";
import { inputTypes } from "../types";

/** A primitive password input with the ability to toggle visibility of the inputs value. */
import { jsx as ___EmotionJSX } from "@emotion/core";
class BarePasswordInput extends PureComponent {
  constructor() {
    super(...arguments);
    // eslint-disable-next-line react/destructuring-assignment
    this.state = {
      show: !this.props.defaultHide
    };
    this.toggleShowState = () => {
      this.setState(prev => ({
        show: !prev.show
      }));
    };
  }
  render() {
    const _this$props = this.props,
      {
        autoComplete
        // eslint-disable-line
        ,

        // eslint-disable-line no-unused-vars
        renderShowToggle
      } = _this$props,
      props = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const {
      show
    } = this.state;
    return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(BareInput, _extends({}, props, {
      autoComplete: autoComplete || show ? 'off' : 'password',
      type: show ? 'text' : 'password'
    })), typeof renderShowToggle === 'function' && renderShowToggle({
      show,
      toggle: this.toggleShowState
    }));
  }
}
BarePasswordInput.defaultProps = {
  defaultHide: true
};
BarePasswordInput.propTypes = {
  /** Used by browswer to auto-fill when available. */
  autoComplete: PropTypes.string,
  /** `true` if you want the input to hide its value by default. */
  defaultHide: PropTypes.bool,
  /** A unique identifier for the input. */
  id: PropTypes.string.isRequired,
  /** `true` when the input is in error state and has been touched. */
  invalid: PropTypes.bool,
  /** A name for the input. */
  name: PropTypes.string.isRequired,
  /** Handler for when the input blurs. */
  onBlur: PropTypes.func.isRequired,
  /** Handler for when the input value changes. */
  onChange: PropTypes.func.isRequired,
  /** Handler for when the input focuses. */
  onFocus: PropTypes.func.isRequired,
  /** Input placeholder */
  placeholder: PropTypes.string,
  /** Render prop that receives arguments with
   * the value show state and a handler to toggle state. */
  renderShowToggle: PropTypes.func,
  /** Value of the input */
  value: PropTypes.string
};
BarePasswordInput.validate = hasValue;
BarePasswordInput.inputType = inputTypes.password;
export { BarePasswordInput };